<app-data-import-selection (fileChangeEvent)="logs.clearLogs()"></app-data-import-selection>
<app-data-import-logs #logs></app-data-import-logs>